import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col px-3 gap-5 max-w-[40rem] mx-auto pb-24" }

import { computed, onMounted } from "vue"
  import { useCompanyStore } from "@/store/company"
  import { useRoute } from "vue-router"
  import { record } from "@/utils/analytics"

  // components
  import AmvContainer from "@/components/workbean-page/about/AmvContainer.vue"
  import BatContainer from "@/components/workbean-page/about/BatContainer.vue"
  import DetailsContainer from "@/components/job-page/DetailsContainer.vue"
  import OfficeContainer from "@/components/workbean-page/about/OfficeContainer.vue"
  import BadgeContainer from "@/components/workbean-page/about/BadgeContainer.vue"
  import ConnectContainer from "@/components/workbean-page/about/ConnectContainer.vue"
  import FaqContainer from "@/components/workbean-page/about/FaqContainer.vue"
  import CoreValueContainer from "@/components/workbean-page/about/CoreValue.vue"
  import PeopleContainer from "@/components/workbean-page/about/PeopleContainer.vue"
  import CovidContainer from "@/components/workbean-page/about/CovidResponse.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AboutPage',
  setup(__props) {

  const companyStore = useCompanyStore()
  const route = useRoute()

  const companyDetails = computed(() => companyStore.companyDetails)
  const companyData = computed(() => [
    {
      icon: "workbean-world",
      description: "Location",
      title: companyDetails.value.location.city || "",
    },
    {
      icon: "workbean-idea",
      description: "Year founded",
      title: companyDetails.value.year_founded || "",
    },
    {
      icon: "workbean-building",
      description: "Company type",
      title: companyDetails.value.company_type || "",
    },
    {
      icon: "workbean-job",
      description: "Work setup",
      title: companyDetails.value.work_setup || "",
    },
    {
      icon: "workbean-group-user",
      description: "Employee count",
      title: companyDetails.value.number_of_employees || "",
    },
    {
      icon: "workbean-group-user",
      description: "Average age",
      title: companyDetails.value.average_age || "",
    },
  ])
  onMounted(() => {
    record({
      event: "CompanyViewPage",
      attributes: {
        link: route.fullPath,
        company_id: companyDetails.value.company_id,
      },
    })
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DetailsContainer, {
      collection: _unref(companyData),
      type: "Company details",
      color: _unref(companyDetails).brand_color || '#7442c8'
    }, null, 8, ["collection", "color"]),
    (_unref(companyDetails).about && _unref(companyDetails).about.length)
      ? (_openBlock(), _createBlock(AmvContainer, {
          key: 0,
          type: "About",
          description: _unref(companyDetails).about
        }, null, 8, ["description"]))
      : _createCommentVNode("", true),
    (_unref(companyDetails).mission && _unref(companyDetails).mission.length)
      ? (_openBlock(), _createBlock(AmvContainer, {
          key: 1,
          type: "Mission",
          description: _unref(companyDetails).mission
        }, null, 8, ["description"]))
      : _createCommentVNode("", true),
    (_unref(companyDetails).vision && _unref(companyDetails).vision.length)
      ? (_openBlock(), _createBlock(AmvContainer, {
          key: 2,
          type: "Vision",
          description: _unref(companyDetails).vision
        }, null, 8, ["description"]))
      : _createCommentVNode("", true),
    (_unref(companyDetails).core_value && _unref(companyDetails).core_value.length)
      ? (_openBlock(), _createBlock(CoreValueContainer, {
          key: 3,
          "core-data": _unref(companyDetails).core_value
        }, null, 8, ["core-data"]))
      : _createCommentVNode("", true),
    (_unref(companyDetails).leadership && _unref(companyDetails).leadership.length)
      ? (_openBlock(), _createBlock(PeopleContainer, {
          key: 4,
          "people-data": _unref(companyDetails).leadership
        }, null, 8, ["people-data"]))
      : _createCommentVNode("", true),
    (_unref(companyDetails).benefits && _unref(companyDetails).benefits.length)
      ? (_openBlock(), _createBlock(BatContainer, {
          key: 5,
          type: "benefits",
          bat: _unref(companyDetails).benefits
        }, null, 8, ["bat"]))
      : _createCommentVNode("", true),
    (_unref(companyDetails).amenities && _unref(companyDetails).amenities.length)
      ? (_openBlock(), _createBlock(BatContainer, {
          key: 6,
          type: "amenities",
          bat: _unref(companyDetails).amenities
        }, null, 8, ["bat"]))
      : _createCommentVNode("", true),
    (_unref(companyDetails).technologies && _unref(companyDetails).technologies.length)
      ? (_openBlock(), _createBlock(BatContainer, {
          key: 7,
          type: "tech stack",
          bat: _unref(companyDetails).technologies
        }, null, 8, ["bat"]))
      : _createCommentVNode("", true),
    (_unref(companyDetails).covid_response)
      ? (_openBlock(), _createBlock(CovidContainer, {
          key: 8,
          details: _unref(companyDetails).covid_response
        }, null, 8, ["details"]))
      : _createCommentVNode("", true),
    (_unref(companyDetails).location)
      ? (_openBlock(), _createBlock(OfficeContainer, {
          key: 9,
          address: {
        city: _unref(companyDetails).location.city,
        country: _unref(companyDetails).location.country,
        fullAddress: _unref(companyDetails).location.full_address,
        coordinates: _unref(companyDetails).location.coordinates,
        area: _unref(companyDetails).location.area,
      },
          "company-logo": _unref(companyDetails).logo
        }, null, 8, ["address", "company-logo"]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createBlock(BadgeContainer, { key: 10 }))
      : _createCommentVNode("", true),
    ((_unref(companyDetails).socials && _unref(companyDetails).socials.length) || _unref(companyDetails).url)
      ? (_openBlock(), _createBlock(ConnectContainer, {
          key: 11,
          socials: _unref(companyDetails).socials,
          company: _unref(companyDetails).name,
          color: _unref(companyDetails).brand_color,
          url: _unref(companyDetails).url
        }, null, 8, ["socials", "company", "color", "url"]))
      : _createCommentVNode("", true),
    _createVNode(FaqContainer, {
      details: _unref(companyDetails).faq,
      "submit-button-color": _unref(companyDetails).brand_color
    }, null, 8, ["details", "submit-button-color"])
  ]))
}
}

})